module.exports = __webpack_public_path__ + "img/texiao-_0000s_0011_12.770e569d.png";